var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 12.7214V16.5881H22.1333C22.4 16.5881 22.5333 16.8547 22.5333 17.1214L22 19.6547C22 19.7881 21.7333 19.9214 21.6 19.9214H18.6667V29.6547H14.6667V20.0547H12.4C12.1333 20.0547 12 19.9214 12 19.6547V17.1214C12 16.8547 12.1333 16.7214 12.4 16.7214H14.6667V12.3214C14.6667 10.0547 16.4 8.32141 18.6667 8.32141H22.2667C22.5333 8.32141 22.6667 8.45474 22.6667 8.72141V11.9214C22.6667 12.1881 22.5333 12.3214 22.2667 12.3214H19.0667C18.8 12.3214 18.6667 12.4547 18.6667 12.7214Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 29.6547H12C5.33332 29.6547 2.66666 26.988 2.66666 20.3214V12.3214C2.66666 5.6547 5.33332 2.98804 12 2.98804H20C26.6667 2.98804 29.3333 5.6547 29.3333 12.3214V20.3214C29.3333 26.988 26.6667 29.6547 20 29.6547Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.e272b7a694f1c9c30b02b7d05144ae65.svg";
export { ForwardRef as ReactComponent };